<template>
    <v-toolbar app class="uf-toolbar" :class="{ 'is-overlay' : overlayMode }">
        <slot></slot>
    </v-toolbar>
</template>

<script>
export default {
  name: 'UfToolbar',
  props: {
    overlayMode: { type: Boolean, default: false },
  },
};
</script>

<style lang="stylus">
    .v-toolbar.uf-toolbar {
        background-color: rgba(#17263C, .0)
        background-image: linear-gradient(to bottom, rgba(#17263C, 0), rgba(#17263C, 0))
        box-shadow: 0 0 32px 0 rgba(#17263C, 0)
        transition: all .25s

        &:before {
            content: ''
            display: block
            position: absolute
            top: 0
            left: 0
            right: 0
            bottom: -200%
            background-image: linear-gradient(to bottom, rgba(#F0F3F6, 1) 25%, rgba(#F0F3F6, 0))
            pointer-events: none
            opacity: 1
            transition: opacity .25s
        }
    }

    .v-toolbar.uf-toolbar.is-overlay {
        background-color: rgba(#F18E00, .85)
        background-image: linear-gradient(to bottom, rgba(#F18E00, .25), rgba(#F18E00, 0))
        box-shadow: 0 0 32px 0 rgba(#17263C, .5)
        color: #fff
        backdrop-filter: blur(5px)

        &:before {
            opacity: 0
        }

        .v-icon {
            color: #fff
        }

        .v-toolbar__subtitle {
            display: none
        }
    }

    .v-toolbar__content {
        position: relative
    }

</style>
